import React, { useState } from "react";
import questionMarkFullGray12 from "@src/assets/svg/question-mark-full-gray-12.svg";
import styles from "./help-icon-popover.module.scss";

const cssClassName = "help-icon-popover";

interface HelpIconPopoverProps {
  helpLabel: string;
  helpText: string;
}

export const HelpIconPopover = ({
  helpLabel,
  helpText,
}: HelpIconPopoverProps) => {
  const [isHelpPopoverOpen, setIsHelpPopoverOpen] = useState(false);

  return (
    <span
      className={styles[cssClassName]}
      onMouseEnter={() => setIsHelpPopoverOpen(true)}
      onMouseLeave={() => setIsHelpPopoverOpen(false)}
    >
      <span className={styles[`${cssClassName}__trigger`]}>
        <span className={styles[`${cssClassName}__label`]}>{helpLabel}</span>
        <img
          src={questionMarkFullGray12}
          alt={helpLabel}
          className={styles[`${cssClassName}__icon`]}
        />
      </span>
      {isHelpPopoverOpen && (
        <div className={styles[`${cssClassName}__popover-wrapper`]}>
          <div className={styles[`${cssClassName}__popover`]}>
            {helpText.split("\n").map((line) => (
              <p key={line} className={styles[`${cssClassName}__line`]}>
                {line}
              </p>
            ))}
          </div>
        </div>
      )}
    </span>
  );
};
